import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ResponsiveAppBar from './components/ResponsiveAppBar';
import { useMediaQuery } from '@mui/material';

import { createContext, useMemo, useState } from 'react';
import './App.css';
import Routes from './Routes';

const ColorModeContext = createContext({ toggleColorMode: () => {} });

function CptApp() {
    const [mode, setMode] = useState(
        useMediaQuery('(prefers-color-scheme: dark)') ? 'dark' : 'light'
    );

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) =>
                    prevMode === 'light' ? 'dark' : 'light'
                );
            },
            changeColorMode: (color) => {
                setMode(color);
            },
        }),
        []
    );

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: mode,
                },
            }),
        [mode]
    );

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <ResponsiveAppBar appName={'Mon app'} colorMode={colorMode} />
                <Routes />
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
}

export default CptApp;
